/* PRC EDITED: (PRC) desktop dropdown menus open on hover, as on the live Impulse theme.
   Mouse/trackpad only — touch and keyboard keep Dawn's click/Enter toggle on the summary.
   The parent title is a link (snippets/header-dropdown-menu.liquid), so clicking it opens the collection. */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const CLOSE_DELAY = 150;

  const setOpen = (details, open) => {
    if (details.open === open) return;
    if (open) details.setAttribute('open', '');
    else details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', open);
  };

  const init = () => {
    const menus = document.querySelectorAll('.header__inline-menu header-menu');
    menus.forEach((menu) => {
      const details = menu.querySelector(':scope > details');
      if (!details || menu.dataset.prcHover) return;
      menu.dataset.prcHover = 'true';
      let closeTimer;

      menu.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        menus.forEach((other) => {
          if (other === menu) return;
          const otherDetails = other.querySelector(':scope > details');
          if (otherDetails) setOpen(otherDetails, false);
        });
        setOpen(details, true);
      });

      menu.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => setOpen(details, false), CLOSE_DELAY);
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* The header section can be re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', init);
})();
